import { create } from "zustand";
import { persist } from "zustand/middleware";

export interface BeneficiaryTerms {
	singular: string;
	plural: string;
}

export interface BeneficiaryTermStore {
	singular: string | null;
	plural: string | null;
	isLoaded: boolean;
	_hasHydrated: boolean;
	setTerms: (terms: BeneficiaryTerms) => void;
	clearTerms: () => void;
	setHasHydrated: (state: boolean) => void;
}

export const useBeneficiaryTermStore = create<BeneficiaryTermStore>()(
	persist(
		(set) => ({
			singular: null,
			plural: null,
			isLoaded: false,
			_hasHydrated: false,
			setTerms: (terms: BeneficiaryTerms) =>
				set({
					singular: terms.singular,
					plural: terms.plural,
					isLoaded: true,
				}),
			clearTerms: () =>
				set({
					singular: null,
					plural: null,
					isLoaded: false,
				}),
			setHasHydrated: (state: boolean) => set({ _hasHydrated: state }),
		}),
		{
			name: "BeneficiaryTermStore",
			onRehydrateStorage: () => (state) => {
				state?.setHasHydrated(true);
			},
			partialize: (state) => ({
				singular: state.singular,
				plural: state.plural,
				isLoaded: state.isLoaded,
			}),
		},
	),
);
